// homeTheme.js
// Shared layout constants and color tokens for the Home redesign (Option A).
// See docs/superpowers/specs/2026-09-16-home-redesign.md §3.
import { getMainContentColors } from "../MainContentArea";

export const HOME = {
  radius: 12,
  gap: 16,
  pad: 18,
  heroRing: 3,
  rowPadY: 10,
  labelSize: 13,
  titleSize: 14,
  heroTitleSize: 20,
  statSize: 24,
  weeklyGoalDays: 5,
  dueSoonDays: 7,
  maxAttention: 5,
  maxDueSoon: 5,
  maxSuggested: 3,
  maxRecent: 6,
  maxToReview: 3,
};

export const SEMANTIC_LIGHT = {
  brand: "#0077b6",
  brandSoft: "#e0f2fe",
  amber: "#d97706",
  amberSoft: "#fef3c7",
  green: "#15803d",
  greenSoft: "#dcfce7",
  red: "#b91c1c",
  redSoft: "#fee2e2",
  ink3: "#94a3b8",
  line: "#e2e8f0",
};

export const SEMANTIC_DARK = {
  brand: "#60a5fa",
  brandSoft: "#1e3a5f",
  amber: "#fbbf24",
  amberSoft: "#3b2f0b",
  green: "#34d399",
  greenSoft: "#0f2f22",
  red: "#f87171",
  redSoft: "#3b1212",
  ink3: "#64748b",
  line: "#2e3d55",
};

export const homeColors = (isDarkMode) => ({
  ...getMainContentColors(isDarkMode),
  ...(isDarkMode ? SEMANTIC_DARK : SEMANTIC_LIGHT),
});
